function intraTabs() {
  let tabs = $("[data-news-tab]");

  tabs.on("click", (e) => {
    let clickedTab = e.currentTarget;
    let contentSelector = clickedTab.dataset.target;
    let content = findContent(contentSelector);
    toggleTab(clickedTab);
    closeOtherContents(contentSelector);
    toggleContent(content);
  });

  function toggleTab(clickedTab) {
    if (!$(clickedTab).hasClass("tab--active")) {
      let otherActiveTabs = $(tabs).filter(":not(.collapse)").not(clickedTab);
      otherActiveTabs.removeClass("tab--active");
      $(clickedTab).addClass("tab--active");
    }
  }

  function findContent(contentSelector) {
    let content = $(contentSelector);
    return content;
  }

  function closeOtherContents(contentSelector) {
    let otherOpenContents = $(`[data-news-tab-content].show:not(${contentSelector})`);
    otherOpenContents.removeClass("show");
  }

  function toggleContent(content) {
    if (!$(content).hasClass("show")) {
      $(content).addClass("show");
    }
  }
}

$(() => {
  intraTabs();
});
